import { render, staticRenderFns } from "./level2.vue?vue&type=template&id=3c557184&"
import script from "./level2.vue?vue&type=script&lang=ts&"
export * from "./level2.vue?vue&type=script&lang=ts&"
import style0 from "./level2.vue?vue&type=style&index=0&id=3c557184&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports